// Angular
import { Component, Output, OnInit, Input, EventEmitter } from "@angular/core";
// Models
import { Club } from "./../../models/club";
// Services
import { ElasticService } from "./../../services/elastic";
// External
import * as lodash from "lodash";
import { Subject } from "rxjs/Subject";

@Component({
  selector: "app-club-select",
  templateUrl: "./club-select.component.html",
  styleUrls: ["./club-select.component.scss"],
})
export class ClubSelectComponent implements OnInit {
  @Input()
  parentSubject: Subject<any>;
  @Output() onChange: EventEmitter<Club>;
  @Input("seachType") seachType: string;
  @Input("placeholder") placeholder: string = "Club";
  public query: string;
  public clubs: Array<Club>;

  private typingDelay: any;

  constructor(private elasticSearch: ElasticService) {
    this.onChange = new EventEmitter();
    this.query = "";
  }

  ngOnInit() {
    if (this.parentSubject) {
      this.parentSubject.subscribe((event) => {
        this.query = "";
        this.clubs = [];
      });
    }
  }

  searchMention() {
    let queryParams = {};
    if (this.query == undefined || this.query == "") {
      queryParams = {
        index: "users",
        type: this.seachType ? this.seachType : "club",
        size: 10,
        "body/query/bool/must/query_string/query": `*`,
        "body/query/bool/must/query_string/fields": ["name"],
      };
    } else {
      queryParams = {
        index: "users",
        type: this.seachType ? this.seachType : "club",
        size: 10,
        "body/query/match_phrase_prefix/name": `${this.query}*`,
      };
    }

    this.elasticSearch
      .search(queryParams)
      .then((result) => {
        this.clubs = [];
        if (result && result["hits"]) {
          lodash.forEach(result["hits"], (item) => {
            console.log(item);
            const club = lodash.assign({ $key: item["_id"] }, item["_source"]);
            this.clubs.push(club);
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  changeQuery() {
    clearTimeout(this.typingDelay);

    this.onChange.emit();

    this.typingDelay = setTimeout(() => {
      this.searchMention();
    }, 400);
  }

  onFocus() {
    this.searchMention();
  }

  onBlur() {
    setTimeout(() => {
      this.clubs = [];
    }, 500);
  }

  chooseClub(club: Club) {
    this.query = club.name + " " + "-" + " " + club.address;
    this.onChange.emit(club);
    this.clubs = [];
  }
}
